import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { AccountService } from '../../service/account.service';

@Component({
  selector: 'app-disconnect-vrchat',
  imports: [MatDialogModule, MatButtonModule],
  templateUrl: './disconnect-vrchat.component.html',
  styleUrl: './disconnect-vrchat.component.less'
})
export class DisconnectVrchatComponent {
  accountService = inject(AccountService);
  dialogRef = inject(MatDialogRef<DisconnectVrchatComponent>);

  get hasActiveSubscription() {
    if (!this.accountService.account.value) return false;
    if (!this.accountService.account.value.connections.patreon) return false;

    return this.accountService.account.value.connections.patreon.subscriptionTier.id >= 0;
  }

  disconnect() {
    this.accountService.disconnectVRChat().subscribe(() => {
      this.dialogRef.close();
    });
  }
}
